import { UnitOfMeasureEnum } from "../../../api/Representation";
import { MarketplaceConsignmentPaymentMethodEnum } from "../../consignments/api/Representation";
import { LoadRateCalcMethodEnum } from "../../vehicleHires/api/Representation";
export var MarketplaceProductSaleTypeEnum;
(function (MarketplaceProductSaleTypeEnum) {
    MarketplaceProductSaleTypeEnum["DISPOSAL"] = "DISPOSAL";
    MarketplaceProductSaleTypeEnum["BUY_BACK"] = "BUY_BACK";
    MarketplaceProductSaleTypeEnum["SUPPLY"] = "SUPPLY";
})(MarketplaceProductSaleTypeEnum || (MarketplaceProductSaleTypeEnum = {}));
